import type { AiUsageTotals } from '../types/organization.types'

// The four token types a provider can report, and the labels they render under.
// tokens.input is UNCACHED input wherever a provider reports a cache split, so
// the four are additive and sum to the total — never add cache_read on top of input.
export const TOKEN_TILES: { key: keyof AiUsageTotals; label: string }[] = [
  { key: 'input_tokens', label: 'Input tokens' },
  { key: 'output_tokens', label: 'Output tokens' },
  { key: 'cache_read', label: 'Cache read' },
  { key: 'cache_creation', label: 'Cache creation' }
]

export const TOKEN_KEYS = TOKEN_TILES.map(t => t.key)

// The one place a token total is summed. AiUsageTotals, AiUsageModel and
// AiUsageMonth all carry these four fields, so every "total tokens" figure in the
// UI goes through here and a new token type only has to be added to the list above.
export const sumTokens = (
  t?: Partial<Record<keyof AiUsageTotals, number>> | null
): number => TOKEN_KEYS.reduce((s, k) => s + (t?.[k] ?? 0), 0)
